import { omit } from 'lodash';
import { getApiBasePath } from 'config/EnvironmentConfig';
import {
  requestedSubmitNotification,
  receivedSubmitNotification,
  errorSubmitNotification
} from 'state/submitNotification/SubmitNotificationActions';
import Store from 'state/Store';
import { setUploadFileError, setUploadFileResults } from 'state/uploadFile/UploadFileActions';

const headerOptions = () => {
  return {
    'X-TRP-Requested-With': 'ii-lfe',
    'apikey': window.config && window.config.apiKey,
    'Content-Type': 'application/json'
  }
};

const postOptions = () => {
  return {
    method: 'POST',
    headers: headerOptions(),
    credentials: 'include'
  }
};

const postOptionsFormData = () => {
  return {
    method: 'POST',
    headers: {
      'X-TRP-Requested-With': 'ii-lfe',
      'apikey': window.config && window.config.apiKey,
    },
    credentials: 'include'
  };
}

const postOptionsWithBody = body => {
  let options = postOptions();
  options.body = JSON.stringify(body);
  return options;
};

const submitOptionsWithBody = (notificationRequest) => {
  let options = postOptionsFormData();
  let formData = new FormData();
  const transformedNotificationRequest = omit(notificationRequest, 'deathCert');
  if(notificationRequest && notificationRequest.deathCert) {
    formData.append('file', notificationRequest.deathCert, notificationRequest.deathCert.name);
  }
  formData.append('notificationRequest', JSON.stringify(transformedNotificationRequest));
  options.body = formData;
  return options;
}

const fileUploadOptionsWithBody = (file) => {
  let postOptions = postOptionsFormData();
  let formData = new FormData();
  formData.append('file', file, file.name);
  postOptions.body = formData;
  return postOptions;
}

export const validateUploadedFile = (file) => {
  lfeFetch('service/validate', fileUploadOptionsWithBody(file))
    .then(response => response.json())
    .then(response => Store.dispatch(setUploadFileResults(response)))
    .catch(error => Store.dispatch(setUploadFileError(error)))
}

export const submitDeathNotification = notificationRequest => {
  Store.dispatch(requestedSubmitNotification());
  lfeFetch('/service/notification/death', submitOptionsWithBody(notificationRequest))
    .then(response => response.json())
    .then(response => Store.dispatch(receivedSubmitNotification(response)))
    .catch(error => Store.dispatch(errorSubmitNotification()))
};

export const submitBusinessNotification = bepRequest => {
  lfeFetch('/service/notification/bep', postOptionsWithBody(bepRequest))
    .then(response => response.json())
    .catch(error => {
      //do nothing)
    })
};

function lfeFetch(input, init) {
  return new Promise((resolve, reject) => {
    const basePath = getApiBasePath();
    fetch((basePath + input), init)
      .then(response => {
        if (response.ok) {
          return response;
        }
        throw response;
      })
      .then(response => {
        return response;
      })
      .then(lfeFetchResolved)
      .catch(lfeFetchRejected);

    function lfeFetchResolved(result) {
      resolve(result);
    }

    function lfeFetchRejected(reason) {
      if (reason.json && reason.body && !reason.bodyUsed) {
        reason.json().then((data) => {
          reject(data);
        });
      } else {
        reject(reason);
      }
    }
  });
}